import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { StatusBar, Style } from '@capacitor/status-bar'

export function isNativeApp() {
  return Capacitor.isNativePlatform()
}

export function getPlatform() {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web'
}

export async function openExternalUrl(url: string) {
  if (!url) {
    return
  }
  if (isNativeApp()) {
    await Browser.open({ url })
    return
  }
  // 运行在 UniApp 壳 WebView 中时，plus API 可用，用它调起系统浏览器
  const plusRuntime = (globalThis as { plus?: { runtime?: { openURL?: (url: string) => void } } }).plus?.runtime
  if (typeof plusRuntime?.openURL === 'function') {
    plusRuntime.openURL(url)
    return
  }
  const win = window.open(url, '_blank', 'noopener,noreferrer')
  // WebView 不支持多窗口时 window.open 返回 null，回退为当前页跳转
  if (!win) {
    window.location.href = url
  }
}

export async function vibrate(style: ImpactStyle = ImpactStyle.Light) {
  if (!isNativeApp()) {
    return
  }
  await Haptics.impact({ style }).catch(() => undefined)
}

export async function syncNativeTheme(isDark: boolean) {
  if (!isNativeApp()) {
    return
  }
  await Promise.all([
    StatusBar.setStyle({ style: isDark ? Style.Light : Style.Dark }),
    StatusBar.setBackgroundColor({ color: isDark ? '#0a0a0a' : '#f7f8fa' }),
  ]).catch(() => undefined)
}
